/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import axiosInstance from "@/api/axios";

export function createThrottledMemoizedFn(Fn: Function, throttleTime = 3000) {
  const cache: Record<string, any> = {};
  let lastCalled = 0;
  let timeout: NodeJS.Timeout | null = null;
  let pendingArgs: any[] | null = null;

  return async (args: any) => {
    const strArgs = JSON.stringify(args[0]) ?? "default";
    const now = Date.now();

    console.log("inside memoize args", args);
    console.log("inside memoize cache", cache);
    console.log("inside memoize strArgs", strArgs);

    if (cache[strArgs]) {
      console.log("inside memoize if block", cache[strArgs]);
      return cache[strArgs];
    }

    // If throttled, wait until the timeout
    if (now - lastCalled < throttleTime) {
      return new Promise((resolve) => {
        if (timeout) clearTimeout(timeout);

        pendingArgs = args;
        timeout = setTimeout(
          async () => {
            const strArgs = JSON.stringify(pendingArgs?.[0]) ?? "default";
            const result = await Fn(pendingArgs);
            cache[strArgs] = result;
            lastCalled = Date.now();
            resolve(result);
          },
          throttleTime - (now - lastCalled)
        );
      });
    }

    // Execute immediately
    lastCalled = now;
    const result = await Fn(args);
    cache[strArgs] = result;
    console.log("inside memoize else block", cache);
    return result;
  };
}
// const memoize = (Fn: Function) => {
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   const cache = {} as any;

//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   return async (args: any) => {
//     // let strArgs = "default";
//     console.log("inside memoize args", args);
//     console.log("inside memoize cache", cache);
//     // if(args) {
//     const strArgs = JSON.stringify(args[0]) ?? "default";
//     console.log("inside memoize strArgs", strArgs);
//     // }
//     if (cache[strArgs]) {
//       console.log("inside memoize if block", cache[strArgs]);
//       return cache[strArgs];
//     } else {
//       const result = await Fn(args);
//       cache[strArgs] = result;
//       console.log("inside memoize else block", cache);
//       return result;
//     }
//   };
// };

export const getActivityTypeAPI = createThrottledMemoizedFn(
  async (params: object) => {
    try {
      const response = await axiosInstance({
        method: "GET",
        url: "/odoo/api/v1/activity/type",
        params: params,
      });
      console.log("response", response);
      return response.data.data.types;
    } catch (err) {
      console.log("err", err);
    }
  }
);

export const getScheduledActivitiesbyLeadID = async (params: {
  leadId: string | number;
}) => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/odoo/api/v1/crm/leads/scheduledActivities",
      params: {
        ...params,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    });
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

export const createLeadActivity = async (body: object) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/activity",
      data: body,
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};


export const updateLeadActivity = async (body: object) => {
  try {
    const response = await axiosInstance({
      method: "PUT",
      url: "/odoo/api/v1/activity",
      data: body,
    });
    console.log("response", response);
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

export const markAsDoneActivity = async (body: object) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/activity/done",
      data: body,
    });
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};

export const cancelActivity = async (body: object) => {
  try {
    const response = await axiosInstance({
      method: "POST",
      url: "/odoo/api/v1/activity/cancel",
      data: body,
    });
    return response.data;
  } catch (err) {
    console.log("err", err);
  }
};
